export default "__VITE_ASSET__DhVB0rP1__";